export const AUTH0_SCOPES = 'openid profile email offline_access';
